import { FabricObject } from 'fabric';

import { TEXT_PLACEHOLDER } from '../draw-canvas.constants';
import { isTextbox } from './is-textbox';
/**
 * Serialized or live canvas object: true if it's a textbox with no real content.
 */
export function isEmptyTextbox(obj: FabricObject): boolean {
  if (!isTextbox(obj)) {
    return false;
  }
  const text = obj.text ?? '';
  return text === TEXT_PLACEHOLDER || text.trim() === '';
}
